import {Component, ElementRef, Inject, OnInit, ViewChild} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogContent} from "@angular/material/dialog";
import {MessageService} from "src/app/core/services/services/message.service";
import {EmployeeService} from "src/app/core/services/services/employee.service";
import {AlertEnum} from "src/app/core/models/Enums/AlertEnum";
import {EditProjectAccessDialogData} from "./edit-project-access-dialog.interface";
import {TranslateService} from "@ngx-translate/core";
import {TranslatableComponent} from "src/app/core/models/TranslatableComponent";
import {Employee} from "src/app/core/models/Employee";
import {MatIcon} from "@angular/material/icon";
import {MatProgressBar} from "@angular/material/progress-bar";
import {CdkScrollable} from "@angular/cdk/scrolling";
import {EmployeeDragDropListComponent} from "./employee-drag-drop-list/employee-drag-drop-list.component";

@Component({
	selector: "app-edit-project-access-dialog",
	templateUrl: "./edit-project-access-dialog.component.html",
	styleUrls: ["./edit-project-access-dialog.component.scss"],
	imports: [MatIcon, MatProgressBar, CdkScrollable, MatDialogContent, EmployeeDragDropListComponent],
})
export class EditProjectAccessDialogComponent extends TranslatableComponent implements OnInit {
	@ViewChild("appEmployeeList") appEmployeeList: ElementRef;
	@ViewChild("appProjectAssignedEmployeesList") appProjectAssignedEmployeesList: ElementRef;

	loading = true;
	employeesWithAccess: Employee[] = [];

	constructor(
		public dialogRef: MatDialogRef<EditProjectAccessDialogComponent>,
		public translate: TranslateService,
		@Inject(MAT_DIALOG_DATA) public data: EditProjectAccessDialogData,
		private employeeService: EmployeeService,
		private messageService: MessageService,
	) {
		super(translate, "EditProjectAccessDialogComponent");
		this.translate = translate;
		dialogRef.addPanelClass("mep-dialog");
	}

	ngOnInit(): void {
		this.employeeService.fetchEmployeesWithAccess(this.data.sharePointId).subscribe((employeesWithAccess) => {
			this.employeesWithAccess = employeesWithAccess;
			this.loading = false;
		});
	}

	saveEmployeeAccess() {
		this.loading = true;
		this.employeeService.saveEmployees(this.data.sharePointId, this.employeesWithAccess).subscribe(() => {
			this.messageService.add(this._lang("success-message"), AlertEnum.SUCCESS);
			this.dialogRef.close();
		});
	}

	closeDialog() {
		this.dialogRef.close();
	}
}
